import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { UserService } from "../../services/user/user.service";
import { getUrlParamValue } from "../../util/url.util";

@Component({
  standalone: false,
  selector: './app-auto-login-metrics',
  template: ''
})
export class AutoLoginMetricsComponent implements OnInit, OnDestroy {

  private paramsSubscription: Subscription;

  constructor(private userService: UserService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    this.paramsSubscription = this.route.params.subscribe(params => {
      const token = params["token"];
      if (token) {
        const target = getUrlParamValue(window.location.href, "target") || "dashboard";
        this.doAutoLogin(token, decodeURIComponent(target));
      }
    });
  }

  ngOnDestroy(): void {
    this.paramsSubscription.unsubscribe();
  }

  private async doAutoLogin(token: string, target: string) {
    if (await this.userService.autoLoginMetrics(token)) {
      const user = this.userService.getUser();
      user.id = undefined;
      this.userService.setUser(user);
      this.router.navigate(["/" + target]);
    }
  }
}
